import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import cn from "classnames";
import Button from "../../../../../components/Buttons/button";
import Pill from "../../../../Pill/pill";
import BasicModal from "../../../../models/models";
import Unicon from "../../../../../assets/images/arrow-down-circle.svg";
import Search from "../../../../../assets/images/search.png";
import {
  getApprovalRules,
  selectCompanyDashboard,
} from "../../../../../redux/slices/companyDashboardSlice";
import { selectUser } from "../../../../../redux/slices/userSlice";

const ApprovalFlows = ({ setModel }) => {
  const dispatch = useDispatch();
  const [popup, setPopup] = useState(false);
  const [state, setState] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortedRules, setSortedRules] = useState([]);
  const [selectedApprovalFlow, setSelectedApprovalFlow] = useState(null);
  const userState = useSelector(selectUser);
  const companyState = useSelector(selectCompanyDashboard);
  const { newRuleData, approvalRulesData, updatedRuleData, deletdRuleData } = companyState;
  const { userDetails } = userState;
  const adminRole = userDetails?.user?.role;
  const approvalRules = approvalRulesData?.approval_rules;

  const displayRules = sortedRules?.filter((rule) =>
    (rule.name ?? "").toLowerCase().includes((searchTerm ?? "").toLowerCase())
  );

  useEffect(() => {
    dispatch(getApprovalRules());
  }, [dispatch ,newRuleData, updatedRuleData]);

  useEffect(() => {
    dispatch(getApprovalRules());
    setPopup(false)
  }, [deletdRuleData]);

  useEffect(() => {
    if (updatedRuleData) {
      setSelectedApprovalFlow(null);
    }
  }, [updatedRuleData]);

  useEffect(() => {
    if (approvalRules) {
      setSortedRules([...approvalRules]);
    }
  }, [approvalRules]);

  const handleSortName = () => {
    const sorted = [...approvalRules].sort((a, b) => {
      if (sortOrder === "asc") {
        return a.name.localeCompare(b.name);
      } else {
        return b.name.localeCompare(a.name);
      }
    });
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setSortedRules(sorted);
  };

  const handleSortCategory = () => {
    const sorted = [...approvalRules].sort((a, b) => {
      if (sortOrder === "asc") {
        return a.category.name.localeCompare(b.category.name);
      } else {
        return b.category.name.localeCompare(a.category.name);
      }
    });
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    setSortedRules(sorted);
  };

  const handleManage = (rule) => {
    setSelectedApprovalFlow(rule);
    setPopup(true);
    setState(64);
  };

  return (
    <div className="px-3 md:px-4 pt-2 md:pt-6 ManageServicesBox ">
      <div className="headingBox flex justify-between items-center md:mb-6 md:px-4">
        <h2 className="md:text-2xl font-bold">Approval Flows</h2>
        {(adminRole === "admin") && (
          <Button
            onClick={() => {
              setSelectedApprovalFlow(null);
              setPopup(true);
              setState(64);
            }}
            outlined={true}
            hoverColor={true}
            secondary={true}
            secondaryHoverOutlined={true}
          >
            Add Approval Flow
          </Button>
        )}
      </div>

      <div className="searchBox mt-2 md:mt-5 md:mx-4">
        <img src={Search} alt="icon" className="searchIcon" />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search approval flows"
          className="searchInput"
        />
      </div>
      <div className="w-[100%] !mt-0 scrollbar-hide scrollable_data">
        <div className="overflow-x-auto overflow-y-auto scrollbar-hide">
          <table className="w-full whitespace-nowrap md:whitespace-initial">
            <thead className="table-head md:py-2 sticky top-0 bg-[#363D50]">
              <tr>
                <th
                  className={`text-left text-secondary border-[#434A5D] md:py-[12px] px-[4px] w-[400px]`}
                >
                  <Button
                    className="sorting_btn_wrapper"
                    secondaryHoverOutlined={true}
                    outlined={true}
                    onClick={handleSortName}
                  >
                    <span className="flex items-center text-[#A5AEBC]">
                      Flow Name
                      <img
                        className={cn("sortingicon", {
                          "rotate-180": sortOrder === "desc",
                        })}
                        src={Unicon}
                        alt="icon"
                      />
                    </span>
                  </Button>
                </th>
                <th
                  className={`text-left text-secondary border-[#434A5D] py-[12px] px-[8px]`}
                >
                  <Button
                    className="sorting_btn_wrapper"
                    secondaryHoverOutlined={true}
                    outlined={true}
                    onClick={handleSortCategory}
                  >
                    <span className="flex items-center text-[#A5AEBC]">
                      Category
                      <img
                        className={cn("sortingicon", {
                          "rotate-180": sortOrder === "desc",
                        })}
                        src={Unicon}
                        alt="icon"
                      />
                    </span>
                  </Button>
                </th>
                <th
                  className={`text-right text-secondary border-[#434A5D] py-[12px] px-[8px]`}
                >
                  &nbsp;
                </th>
              </tr>
            </thead>
            <tbody>
              {displayRules?.map((rule) => (
                <tr key={rule.id}>
                  <td className="text-left text-secondary !text-[#FFFFFF] p-[16px]">
                    <div className="flex flex-row items-center gap-[10px]">
                      <div className="w-[40px] h-[40px] rounded-lg bg-[#242B3E] flex items-center justify-center">
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M16.6648 11.9451C18.5577 11.6286 20.0003 9.98278 20.0003 8C20.0003 5.79086 18.2095 4 16.0003 4C13.7912 4 12.0003 5.79086 12.0003 8C12.0003 9.98278 13.443 11.6286 15.3359 11.9451C15.3344 11.9632 15.3337 11.9815 15.3337 12V15.2494H12.7509C10.1272 15.2494 8.00033 17.3763 8.00033 20C8.00033 20.0185 8.00108 20.0368 8.00256 20.0549C6.10965 20.3714 4.66699 22.0172 4.66699 24C4.66699 26.2091 6.45785 28 8.66699 28C10.8761 28 12.667 26.2091 12.667 24C12.667 22.0172 11.2243 20.3714 9.33143 20.0549C9.3329 20.0368 9.33366 20.0185 9.33366 20C9.33366 18.1127 10.8636 16.5827 12.7509 16.5827H19.2497C21.137 16.5827 22.667 18.1127 22.667 20C22.667 20.0185 22.6677 20.0368 22.6692 20.0549C20.7763 20.3714 19.3337 22.0172 19.3337 24C19.3337 26.2091 21.1245 28 23.3337 28C25.5428 28 27.3337 26.2091 27.3337 24C27.3337 22.0172 25.891 20.3714 23.9981 20.0549C23.9996 20.0368 24.0003 20.0185 24.0003 20C24.0003 17.3763 21.8734 15.2494 19.2497 15.2494H16.667V12C16.667 11.9815 16.6662 11.9632 16.6648 11.9451ZM16.0003 10.6667C17.4731 10.6667 18.667 9.47276 18.667 8C18.667 6.52724 17.4731 5.33333 16.0003 5.33333C14.5276 5.33333 13.3337 6.52724 13.3337 8C13.3337 9.47276 14.5276 10.6667 16.0003 10.6667ZM11.3337 24C11.3337 25.4728 10.1398 26.6667 8.66699 26.6667C7.19423 26.6667 6.00033 25.4728 6.00033 24C6.00033 22.5272 7.19423 21.3333 8.66699 21.3333C10.1398 21.3333 11.3337 22.5272 11.3337 24ZM26.0003 24C26.0003 25.4728 24.8064 26.6667 23.3337 26.6667C21.8609 26.6667 20.667 25.4728 20.667 24C20.667 22.5272 21.8609 21.3333 23.3337 21.3333C24.8064 21.3333 26.0003 22.5272 26.0003 24Z"
                            fill="white"
                          />
                        </svg>
                      </div>
                      <div className="flex flex-col">
                        <span className="text-secondary lineHeight !text-[#FFFFFF] !text-left !font-medium capitalize">
                          {rule.name}
                        </span>
                      </div>
                    </div>
                  </td>
                  <td className="text-left text-secondary !text-[#FFFFFF] pl-[20px] p-[16px] !font-medium">
                    <Pill outline={true}>{rule.category?.name || "N/A"}</Pill>
                  </td>
                  <td className="flex items-center justify-end text-secondary !text-[#FFFFFF] pl-[20px] p-[16px] !font-medium font_12px">
                    <Button
                      outlined={true}
                      hoverColor={true}
                      secondary={true}
                      secondaryHoverOutlined={true}
                      onClick={() => handleManage(rule)}
                    >
                      Manage
                    </Button>
                  </td>  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {popup && (
        <BasicModal
          state={state}
          popup={popup}
          setPopup={setPopup}
          setState={setState}
          setModel={setModel}
          selectedApprovalFlow={selectedApprovalFlow}
        />
      )}
    </div>
  );
};

export default ApprovalFlows;